/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

import React, { Component } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Icon, Pagination, WhiteSpace } from "antd-mobile";
import { FormattedMessage } from "react-intl";
import { intl } from "../../services/intlGlobalProvider";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import EnterNewPassSection from "./EnterNewPassSection";
import EnterPhoneNumSection from "./EnterPhoneNumSection";
import VerifyCodeSection from "./VerifyCodeSection";
import NavBar from "../../components/NavBar";
import LoadingIndicator from "../../components/LoadingIndicator";
import Toast from "../../utils/Toast";
import Theme from "../../utils/Theme";
import * as selectors from "../../selectors";
import * as authActions from "../../actions/auth";
import "./index.css";

const StyledContainer = styled.div`
  background: white;
  position: absolute;
  max-width: ${Theme.MaxWidth};
  overflow-x: hidden;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`;

const StyledAnimatedContainer = styled.div`
  background: white;
  min-height: 100vh;
  max-width: ${Theme.MaxWidth};
  width: 100%;
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`;

const StyledLeftIconContainer = styled.div`
  padding: 0 0.6em
  cursor: pointer;
  display: flex;
  height: 100%;
  justify-content: flex-start;
  align-items: center;
`;

const StyledMainContainer = styled.div`
  margin-top: 4.1em;
  width: 80%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
`;

class ForgotPasswordPage extends Component {
  constructor(props) {
    super(props);
    const { intl } = this.props;

    this.state = {
      error: null,
      mobileNumber: "",
      securityCode: "",
      newPassword: "",
      newConfirmPassword: "",
      animationClass: null,
      intervalId: null,
      countdown: 0,
      position: 1
    };
  }

  componentDidMount() {
    this.setState({ animationClass: "slide-in-right" });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { history } = this.props;

    if (
      this.props.forgetPasswordItemToken !== nextProps.forgetPasswordItemToken
    ) {
      clearInterval(this.state.intervalId);
      let intervalId = setInterval(() => {
        const currentTimeStamp = new Date().getTime() / 1000;
        const countdown =
          nextProps.forgetPasswordItemExpiryTimestamp - currentTimeStamp;

        if (countdown > 0) {
          this.setState({ countdown: countdown });
        } else {
          this.setState({ countdown: 0 });
        }
      }, 1000);

      this.setState({ intervalId: intervalId });
    }

    if (this.props.forgetPasswordStatus !== nextProps.forgetPasswordStatus) {
      if (nextProps.forgetPasswordStatus) {
        this.updatedPosition(2);
      }
    }

    if (
      this.props.resetPasswordWithPhoneStatus !==
      nextProps.resetPasswordWithPhoneStatus
    ) {
      if (nextProps.resetPasswordWithPhoneStatus) {
        this.updatedPosition(3);
      }
    }

    if (
      this.props.resetPasswordWithEmailStatus !==
      nextProps.resetPasswordWithEmailStatus
    ) {
      if (nextProps.resetPasswordWithEmailStatus) {
        history.push("/reset-password-successful");
      }
    }
  }

  componentWillUnmount() {
    clearInterval(this.state.intervalId);
  }

  onPressSubmitResetRequest = () => {
    const { postForgetPasswordRequest } = this.props;
    const { mobileNumber } = this.state;

    let submitData = {
      type: "phone",
      prefix: "+60",
      number: mobileNumber
    };

    postForgetPasswordRequest(submitData);
  };

  onPressSubmitVerifyCode = () => {
    const {
      postResetPasswordWithPhoneRequest,
      forgetPasswordItemToken
    } = this.props;
    const { securityCode } = this.state;

    let submitData = {
      type: "phone",
      token: forgetPasswordItemToken,
      secret: securityCode
    };

    postResetPasswordWithPhoneRequest(submitData);
  };

  onPressSubmitNewPassword = () => {
    const {
      postResetPasswordWithEmailRequest,
      resetPasswordWithPhoneItemToken
    } = this.props;
    const { newPassword, newConfirmPassword } = this.state;

    if (newPassword !== newConfirmPassword) {
      Toast.error(
        intl.formatMessage({ id: "reset.password.confirm.pass.error" })
      );
      return;
    }

    let submitData = {
      type: "email",
      token: resetPasswordWithPhoneItemToken,
      new_password: newPassword,
      confirm_password: newConfirmPassword
    };

    postResetPasswordWithEmailRequest(submitData);
  };

  onBackPressed = () => {
    const { history } = this.props;
    const { position } = this.state;

    if (position === 1) {
      this.setState({ animationClass: "slide-out-right" });

      window.setTimeout(() => {
        history.goBack();
      }, 300);
    } else {
      this.updatedPosition(position - 1);
    }
  };

  updatedPosition = position => {
    this.setState({ position: position });
  };

  onMobileNumChanged = value => {
    this.setState({ mobileNumber: value.replace(/\s/g, "") });
  };

  onSecurityCodeChanged = value => {
    this.setState({ securityCode: value });
  };

  onNewPasswordChanged = value => {
    this.setState({ newPassword: value });
  };

  onNewConfirmPasswordChanged = value => {
    this.setState({ newConfirmPassword: value });
  };

  getNavBar = () => {
    return (
      <NavBar
        middleTitle={
          <FormattedMessage
            id="forgot.password.title"
            defaultMessage="Forgot Password"
            description="Forgot Password Page Title"
          />
        }
        leftIcon={
          <StyledLeftIconContainer>
            <Icon type="left" size="xs" />
            <FormattedMessage
              id="app.back"
              defaultMessage="Back"
              description="Navigate to previous page"
            />{" "}
          </StyledLeftIconContainer>
        }
        onLeftIconClick={() => this.onBackPressed()}
        {...this.props}
      />
    );
  };

  getLoadingIndicator = () => {
    const { forgetPasswordLoading } = this.props;
    const { position } = this.state;

    if (forgetPasswordLoading && position === 2) {
      return <LoadingIndicator />;
    }

    return false;
  };

  getContent = position => {
    const {
      error,
      mobileNumber,
      securityCode,
      newPassword,
      newConfirmPassword,
      countdown
    } = this.state;
    const {
      forgetPasswordLoading,
      resetPasswordWithPhoneLoading,
      resetPasswordWithEmailLoading
    } = this.props;

    switch (position) {
      case 1:
        return (
          <EnterPhoneNumSection
            loading={forgetPasswordLoading}
            error={error}
            mobileNumber={mobileNumber}
            onMobileNumChanged={this.onMobileNumChanged}
            onSubmit={() => this.onPressSubmitResetRequest()}
          />
        );
      case 2:
        return (
          <VerifyCodeSection
            loading={resetPasswordWithPhoneLoading}
            error={error}
            code={securityCode}
            countdown={countdown}
            onCodeChanged={this.onSecurityCodeChanged}
            onResendClicked={() => this.onPressSubmitResetRequest()}
            onSubmit={() => this.onPressSubmitVerifyCode()}
          />
        );
      case 3:
        return (
          <EnterNewPassSection
            loading={resetPasswordWithEmailLoading}
            error={error}
            newPassword={newPassword}
            newConfirmPassword={newConfirmPassword}
            onNewPasswordChanged={this.onNewPasswordChanged}
            onNewConfirmPasswordChanged={this.onNewConfirmPasswordChanged}
            onSubmit={() => this.onPressSubmitNewPassword()}
          />
        );
    }
  };

  render() {
    const { animationClass, position } = this.state;

    return (
      <StyledContainer>
        <StyledAnimatedContainer
          className={animationClass !== null ? animationClass : false}
          onAnimationEnd={() => this.setState({ animationClass: null })}
        >
          {this.getNavBar()}
          {this.getLoadingIndicator()}
          <StyledMainContainer>
            <Pagination
              className={"forgot-password-pagination"}
              mode="pointer"
              total={3}
              current={position}
              style={{ marginTop: "10%" }}
            />
            <WhiteSpace size={"md"} />
            <TransitionGroup>
              <CSSTransition key={position} timeout={300} classNames="fade">
                {this.getContent(position)}
              </CSSTransition>
            </TransitionGroup>
          </StyledMainContainer>
        </StyledAnimatedContainer>
      </StyledContainer>
    );
  }
}

ForgotPasswordPage.propTypes = {
  intl: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  forgetPasswordLoading: PropTypes.bool,
  forgetPasswordStatus: PropTypes.bool,
  forgetPasswordItemToken: PropTypes.string,
  forgetPasswordItemExpiryTimestamp: PropTypes.number,
  resetPasswordWithPhoneLoading: PropTypes.bool,
  resetPasswordWithPhoneStatus: PropTypes.bool,
  resetPasswordWithPhoneItemToken: PropTypes.string,
  resetPasswordWithEmailLoading: PropTypes.bool,
  resetPasswordWithEmailStatus: PropTypes.bool,
  postForgetPasswordRequest: PropTypes.func,
  postResetPasswordWithPhoneRequest: PropTypes.func,
  postResetPasswordWithEmailRequest: PropTypes.func
};

function mapStateToProps(state) {
  return {
    forgetPasswordLoading: selectors.getPostForgetPasswordLoading(state),
    forgetPasswordStatus: selectors.getPostForgetPasswordStatus(state),
    forgetPasswordItemToken: selectors.getPostForgetPasswordItemToken(state),
    forgetPasswordItemExpiryTimestamp: selectors.getPostForgetPasswordExpiryTimestamp(
      state
    ),
    resetPasswordWithPhoneLoading: selectors.getPostResetPasswordWithPhoneLoading(
      state
    ),
    resetPasswordWithPhoneStatus: selectors.getPostResetPasswordWithPhoneStatus(
      state
    ),
    resetPasswordWithPhoneItemToken: selectors.getPostResetPasswordWithPhoneItemToken(
      state
    ),
    resetPasswordWithEmailLoading: selectors.getPostResetPasswordWithEmailLoading(
      state
    ),
    resetPasswordWithEmailStatus: selectors.getPostResetPasswordWithEmailStatus(
      state
    )
  };
}

function mapDispatchToProps(dispatch) {
  return {
    postForgetPasswordRequest: phoneData =>
      dispatch(authActions.postForgetPasswordRequest(phoneData)),
    postResetPasswordWithPhoneRequest: resetData =>
      dispatch(authActions.postResetPasswordWithPhoneRequest(resetData)),
    postResetPasswordWithEmailRequest: resetData =>
      dispatch(authActions.postResetPasswordWithEmailRequest(resetData))
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ForgotPasswordPage);



// WEBPACK FOOTER //
// ./src/containers/ForgotPasswordPage/index.js